import ConeCrusherCS from './ConeCrusherCS.png';
import ConeCrusherCSBW from './ConeCrusherCSBW.png';
import ConeCrusherCS2 from './ConeCrusherCS_2.png';

export const getImageConeCrusherCS = (showCustomModel: boolean) => {
  return showCustomModel ? ConeCrusherCSBW : ConeCrusherCS;
};

export const getImageConeCrusherCS2 = (showCustomModel: boolean) => {
  return showCustomModel ? ConeCrusherCSBW : ConeCrusherCS2;
};
